/**
 * @fileoverview Zod schemas for the Character domain.
 *
 * All schemas use `.describe()` on each field to provide documentation
 * that can be used for AI context and auto-generated docs.
 *
 * Key schemas:
 * - `CharacterV2Schema` - Main character entity with embedded startingSnapshot
 * - `CharacterSnapshotV2Schema` - Point-in-time character state (per chapter)
 * - `CharacterInspirationSchema` - Real-world personality profiles for inspiration
 * - `CharacterV2IdeaSchema` - AI-generated character suggestions
 */

// Barrel export for clean imports
export * from './character-v2';
export * from './character-sub-entities-v2';
export * from './character-ideation-v2';
export * from './personality-profile';
export * from './character-inspiration';
